import classNames from 'classnames';

// Variant-specific classes
export const getBgColor = (variant: string) => {
  switch (variant) {
    case 'blue':
      return 'bg-[radial-gradient(132.21%_97.99%_at_50.13%_30.87%,theme(colors.digital-walmart-blue)_69.5%,theme(colors.atmospheric-white)_70%)]';
    case 'spark-yellow':
      return 'bg-[radial-gradient(132.21%_97.99%_at_50.13%_30.87%,theme(colors.spark-yellow)_69.5%,theme(colors.atmospheric-white)_70%)]';
    case 'sunrise-yellow':
      return 'bg-[radial-gradient(132.21%_97.99%_at_50.13%_30.87%,theme(colors.sunrise-yellow)_69.5%,theme(colors.atmospheric-white)_70%)]';
    case 'dark':
      return 'bg-[radial-gradient(132.21%_97.99%_at_50.13%_30.87%,theme(colors.secondary-dark)_69.5%,theme(colors.dark-mode-background)_70%)]';
    case 'holiday':
      return 'bg-[radial-gradient(132.21%_97.99%_at_50.13%_30.87%,theme(colors.digital-walmart-blue)_69.5%,theme(colors.atmospheric-white)_70%)]';
    default:
      return 'bg-digital-walmart-blue';
  }
};

export const getTextColor = (variant: string) => {
  switch (variant) {
    case 'blue':
      return 'text-white';
    case 'spark-yellow':
      return 'text-black';
    case 'sunrise-yellow':
      return 'text-tertiary-blue';
    case 'dark':
      return 'text-white';
    default:
      return 'text-white';
  }
};

// Wrapper classes
export const wrapperClasses = classNames(
  'simplified-solid-hero',
  'flex flex-col justify-center items-center',
  'px-4 pt-10 pb-14'
);

export const headlineClasses = classNames(
  'font-bold text-4xl md:text-5xl text-center leading-[36px] md:leading-[48px]',
  'm-0'
);

export const subheadlineClasses = classNames(
  'text-lg text-center leading-[27px]',
  'mt-4 mb-8',
  'max-w-[300px] md:max-w-none'
);

export const tooltipClasses = classNames('fill-current');

export const ctaWrapperClasses = classNames(
  'flex flex-col gap-2 justify-center items-center',
  'text-center'
);

export const primaryCTAClasses = classNames('!w-[343px] mx-auto');
